import { Alert, Snackbar } from '@/ui';

import type { FC } from 'react';

interface ConfirmationSnackbarProps {
  autoHideDuration?: number;
  message: string;
  onClose: () => void;
  open: boolean;
}

const ConfirmationSnackbar: FC<ConfirmationSnackbarProps> = ({
  autoHideDuration = 7000,
  message,
  onClose,
  open,
}) => (
  <Snackbar
    anchorOrigin={{ horizontal: 'center', vertical: 'bottom' }}
    autoHideDuration={autoHideDuration}
    open={open}
    onClose={onClose}
  >
    <Alert severity="success" onClose={onClose}>
      {message}
    </Alert>
  </Snackbar>
);

export default ConfirmationSnackbar;
